import { DoPost} from "@/store/Actions";
import querystring from "querystring";
import store from "@/store/Store";

// ХРАНИЛИЩЕ МАРШРУТОВ

export default {
    state() {
        return {
            // список объектов
            routes: [],
            // время обновления кэша new Date().getTime()
            routesCache: null,
            // время жизни кэша в мс (null - бесконечно)
            routesCacheTimeout: null
        }
    },
    getters: {

        // вернуть список объектов
        getRoutes(state) {
            return state.routes;
        },
    },
    mutations: {
        // установить новый список объектов
        setRoutes(state, payload) {
            state.routes = payload;
            state.routesCache = new Date().getTime()
            // console.log('setRoutes', state.routes)
        },

        // очищаем список объектов
        clearRoutes(state) {
            state.routes = [];
        }
    },
    actions: {

        // получение маршрутов по парку
        async doGetRoutes(context, payload) {
            store.commit('clearRoutes')
            let json = {};
            json.jsonPark = payload.park;
            let postPark = JSON.stringify(json.jsonPark);
            await DoPost(
                '/MarshRestController/getParksMarshesRemote',
                querystring.stringify(json) + postPark,
                'setRoutes',
                'Получение маршрутов'
            )
        },
    }
}
